function openflags_desktop() {
    document.getElementById("mydropdown__desktop").classList.toggle("show-flagcomponent");
  }
  
  // Close the dropdown if the user clicks outside of it
  window.onclick = function(event) {
    if (!event.target.matches('.dropbtn')) {
      var dropdowns = document.getElementsByClassName("dropdown-content");
      var i;
      for (i = 0; i < dropdowns.length; i++) {
        var openDropdown = dropdowns[i];
        if (openDropdown.classList.contains('show-flagcomponent')) {
          openDropdown.classList.remove('show-flagcomponent');
        }
      }
    }
  }